var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-image',{staticClass:"logo",class:{"logo-col": _vm.isCollapse},attrs:{"src":_vm.url,"fit":"fill"},on:{"click":_vm.goHome}})
}
var staticRenderFns = []

export { render, staticRenderFns }